import React, { useState } from "react";
import PropTypes from "prop-types";
import { DmsTextFieldMasked } from "dmsbasereact";

// Mask function for CRM (only numbers, max 10 digits per database constraint)
const CrmMask = (value) => {
  value = value.replace(/\D/g, ""); // remove non-numeric
  return value.slice(0, 10); // max 10 digits
};

// Validation function for CRM
const isValidCRM = (value) => {
  const num = value.replace(/\D/g, "");
  return num.length >= 3 && num.length <= 10;
};

export const TextFieldCrm = ({
  name = "crm",
  label = "CRM",
  placeholder = "Enter CRM",
  validateOnBlur = true,
  validateOnChange = false,
  onValidationChange,
  error: externalError,
  helperText: externalHelperText,
  ...props
}) => {
  const [internalError, setInternalError] = useState(false);
  const [internalHelperText, setInternalHelperText] = useState("");

  // External error/helperText takes priority over internal validation
  const error = externalError || internalError;
  const helperText = externalHelperText || internalHelperText;

  const handleValidation = (value) => {
    if (!value) {
      setInternalError(false);
      setInternalHelperText("");
      onValidationChange?.(true);
      return;
    }

    const valid = isValidCRM(value);
    setInternalError(!valid);
    setInternalHelperText(valid ? "" : "Invalid CRM (3-10 digits)");
    onValidationChange?.(valid);
  };

  const handleBlur = (event) => {
    if (validateOnBlur) handleValidation(event.target.value);
  };

  const handleChange = (event) => {
    if (validateOnChange) handleValidation(event.target.value);
    props.onChange?.(event);
  };

  return (
    <DmsTextFieldMasked
      name={name}
      label={label}
      placeholder={placeholder}
      maskFunction={CrmMask}
      error={error}
      helperText={helperText}
      onBlur={handleBlur}
      onChange={handleChange}
      {...props}
    />
  );
};

TextFieldCrm.propTypes = {
  validateOnBlur: PropTypes.bool,
  validateOnChange: PropTypes.bool,
  onValidationChange: PropTypes.func,
};
